<template>
  <div>
      <van-search v-model="value" shape="round" background="#4fc08d" placeholder="请输入搜索关键词"  show-action>
          <template #label>
              <div @click="openDialog">{{type}}</div>
          </template>
          <template #action >
              <div @click="onSearch" >搜索</div>
          </template>
     </van-search>
     <van-cell-group inset  style="margin-top : 10px" >
          <van-cell title="一共多少10条,已经发布10，未发布2" is-link></van-cell>
     </van-cell-group>        
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad">
            <van-cell-group inset v-for="itm in noticeList"  :key = "itm.index" style="margin-top : 10px" >
                <van-cell :label="itm.theme">
                  <template #title>
                    <van-tag> {{ itm.index + 1 }}</van-tag>
                    <van-tag>{{ itm.dat }}</van-tag>
                    <van-tag>未发布</van-tag> | 
                    <van-tag>发布</van-tag> 
                    <van-tag>详情</van-tag> 
                  </template>
                </van-cell>
            </van-cell-group>        
          </van-list>
      </van-pull-refresh>
      <van-popup v-model="showPicker"  round position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          title="查询条件"
          @cancel="showPicker = false"
          @confirm="onConfirm"
        />
      </van-popup>
  </div>
</template>
<script>
  import { Search } from 'vant';
  import  SERVICE_URL from '@/api/url'

  export default {
    name : 'noticeList',
    data () {
      return {
          type : "姓名",
          value:"123123",
          list: [],
          loading: false,
          finished: false,
          refreshing: false,
          showPicker: false,
          columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
          loginForm: {
          userName: '',
          password: ''  ,
          value: '',
          },
          noticeList :[],
          rules: {
          userName: [
            { required: true, message: '请输入用户名', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ]
        },
        showLogin: false
      }
    },
    mounted () {
      for(let i = 0 ; i< 10 ; i++ ) {
              let item = {
                  index: i,
                  theme : "生物安全知识考试生物安全知识考试生",
                  dat : "2022-12-09"
              }
              this.noticeList.push(item);
          }
          console.log(this.exaList);
      this.showLogin = true;
    },
    methods: {
      onConfirm(value){

        this.showPicker = false;
        this.type = value;
      },
      openDialog(){

        this.showPicker = true;
      },
      onSearch(){

        

      },
      onLoad() {
          // 异步更新数据
          // setTimeout 仅做示例，真实场景中一般为 ajax 请求
          setTimeout(() => {
            if (this.refreshing) {
                this.list = [];
                this.refreshing = false;
              }
              for (let i = 0; i < 10; i++) {
                  let item = {
                    id : i,
                    userName:"雷布斯" + i,
                    gender : "男",
                    email : "cxf@lrc.cn",
                    workNo : "2505",
                    deptName : "信息技术部",
                    phone : "18734148493"
                  }
                  this.list.push(item);
              }

              // 加载状态结束
              this.loading = false;
              
              // 数据全部加载完成
              if (this.list.length >= 40) {
                  this.finished = true;
              }
          }, 1000);
      },
      async submitForm (loginInfo) {

        // this 是Vue 
        let _this = this
        let data =JSON.parse(JSON.stringify(this.loginForm))
        this.$refs[loginInfo].validate(async (valid) => {
          if (valid) {
                _this.$store.commit(TOKEN_ID, "11111111111")
                let URL  =  SERVICE_URL + '/user/login'; 
                  // _this.$store.commit(STORE_USER_INFO, _this.loginForm.userName)
                  // _this.$store.commit('tokenId', response.data.data.tokenId)
                  _this.$router.push('manage')
                  _this.$message.success(response.data.message)
            //    axios.post(URL, data).then((response) => {
            //     if (response.data.code === 0) {
            //       // 这里进行存储信息
            //       // 跳转页
            //       _this.$store.commit(STORE_USER_INFO, _this.loginForm.userName)
            //       _this.$store.commit('tokenId', response.data.data.tokenId)
            //       _this.$router.push('manage')
            //       _this.$message.success(response.data.message)
            //     } else {
            //       _this.$message({
            //         showClose: true,
            //         message: response.data.message,
            //         type: 'error',
            //         duration: 0
            //       })
            //     }
            //   }).catch(function (err) {
            //       _this.$message({
            //         showClose: true,
            //         message: err.message,
            //         type: 'error',
            //         duration: 0
            //       })
            // });
          }
        })
      },
      onSearch (){


      },
      onRefresh() {
          // 清空列表数据
          this.finished = false;

          // 重新加载数据
          // 将 loading 设置为 true，表示处于加载状态
          this.loading = true;
          this.onLoad();
      },
    }
  }
</script>

<style lang="less" scoped>
  
</style>



// WEBPACK FOOTER //
// src/mini_pages/question/examList.vue